
import HeaderB from '@/components/HeaderB/HeaderB.vue'
import FooterB from '@/components/FooterB/FooterB.vue'
export default {
  components: {
    HeaderB,
    FooterB
  },

  data() {
    return {
      screen: {
        height: document.documentElement.clientHeight,
        width: document.documentElement.clientWidth
      },
      back:'',
      menus:[
        {
          name:'商城',
          url:'/',
          active:true,
          backgroundImg:'/static/images/HomeTH/home1.jpg'
        },
        {
          name:'交易大厅',
          url:'/HomeChare',
          active:false,
          backgroundImg:'/static/images/HomeTH/home3.jpg'
        },
        {
          name:'竞拍大厅',
          url:'/Menu/AuctionHallList',
          active:false,
          backgroundImg:'/static/images/HomeTH/home3.jpg'
        },
        {
          name:'支持与服务',
          url:'/HomeSupport',
          active:false,
          backgroundImg:'/static/images/HomeTH/home3.jpg'
        },
        {
          name:'联系我们',
          url:'/HomeAbout',
          active:false,
          backgroundImg:'/static/images/HomeTH/home3.jpg'
        },
      ],
      value: "",
      showmsg: "222",
      proxy: {},
    }
  },
  methods: {
    JumpTo(item){
      this.$router.push({
        path:item.url
      });
    },

    // connectServer() {
    //   var $this = this;
    //   var conn = $.hubConnection("http://localhost:10001", { });
    //   $this.proxy = conn.createHubProxy("NoticeHub");
    //   $this.getMsg();
    //   // $this.getMsg1();
    //   conn.start().done((data) => {
    //     $this.sendMsg();
    //   }).fail((data) => {
    //   });
    // },
    // sendMsg() {
    //   var $this = this;
    //   $this.proxy.invoke("showMessage", 'sdsdsdsdsds').done((msg) => {
    //   });
    // },
    // getMsg() {
    //   var $this = this;
    //   $this.proxy.on("showMessage", (data) => {
    //     console.log(data)
    //     $this.showmsg = data;
    //   });
    //
    // },
    // getMsg1(){
    //   var $this = this;
    //   $this.proxy.on("receiveNotice", (data) => {
    //     console.log('receiveNotice');
    //     console.log(data)
    //   })
    // },
  },
  created() {
    // this.connectServer();
  },
  mounted() {
    const self = this;
    window.onresize = () => {
      return (() => {
        self.screen = {
          height: document.documentElement.clientHeight,
          width: document.documentElement.clientWidth
        }
      })();
    }
  },
  computed: {
    view() {
      return {
        height: this.screen.height,
        width: this.screen.width
      }
    },
  },
  watch: {
    $route(val) {

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeLay/HomeLay.js